export default {
  icon: 'mdi-dolly',
  text: 'Fornecedores',
  permissions: [
    { name: 'supplierIndex', text: 'Visualizar fornecedores', value: 0 },
    { name: 'supplierCreateEdit', text: 'Cadastrar/Editar fornecedores', value: 0 }
  ]
}